<template lang="html">
    <div class="document" v-loader-overlay="progressDocs">
        <iframe class="can-scroll" v-bind:src="previewUrl" ref="documentIframe"></iframe>
        <div class="info">
            <div class="status">
                <span>{{ 'Статус: ' + statusName }}</span>
            </div>
            <hr>
            <div class="button-container" v-if="document.status == 'ACTUAL'">
                <z-button class="document-button" transperent  v-on:click.prevent="sendDocDialog = true"> 
                    <z-icon v-bind:icon="['fa', 'envelope']"></z-icon>
                    <span>Отправить по E-mail</span>
                </z-button>                
                <z-button class="document-button" transperent v-on:click.prevent="printDoc()"> 
                    <z-icon v-bind:icon="['fa', 'print']"></z-icon>
                    <span>Распечатать</span>
                </z-button>
                <z-button class="document-button" transperent v-on:click.prevent="updateDoc()" v-if="document && document.id && (!$props.block || isUserManager)">
                    <z-icon v-bind:icon="['fa', 'arrows-rotate']"></z-icon>
                    <span>Обновить данные</span>
                </z-button>
                <z-button class="document-button" transperent v-on:click.prevent="showEditDialog()" v-if="document && document.id && !$props.block && isUserAdmin">
                    <z-icon v-bind:icon="['fa', 'pen']"></z-icon>
                    <span>Редактировать</span>
                </z-button>
                <z-button class="document-button" transperent v-on:click.prevent="removeDoc()" v-if="document && document.id && !$props.block && $props.removable">
                    <z-icon v-bind:icon="['fa', 'trash']"></z-icon>
                    <span>Удалить</span>
                </z-button>
            </div>
            <div class="button-container" v-if="document.status == 'DELETED'">
                <z-button class="document-button" transperent v-on:click.prevent="restoreDoc()" v-if="document && document.id && !$props.block">
                    <z-icon v-bind:icon="['fa', 'trash-arrow-up']"> restore_from_trash </z-icon>
                    <span>Восстановить</span>
                </z-button>
            </div>
            <hr>
            <div v-if="document.created_at">
                <span>{{'Дата создания: ' + moment(document.created_at).format('DD.MM.YYYY')}} </span>
                <b>{{' (' + ((document.creater && document.creater.login) ? document.creater.login :  'клиент')  + ')' }}</b>
            </div>

            <div v-if="document.updated_at">
                <span v-if="document.last_print_date">
                    <span>{{'Дата последний печати: ' + moment(document.last_print_date).format('DD.MM.YYYY')}} </span>
                    <b>{{((document.last_printer && document.last_printer.login) ? ' (' + document.last_printer.login + ')' : ' (клиент)')}}</b>
                </span>
                <span v-else>
                    <span>{{'Дата последний печати: '}}</span>
                    <b>Не был распечатан</b>
                </span>
            </div>

            <div v-if="document.last_email">
                <span>{{'Последняя отправка: '}}</span>
                <b>{{ moment(document.last_email.created_at).format('DD.MM.YYYY') }}, {{ document.last_email.success == '1' ? 'доставлено' : 'не доставлено' }}</b>
                <md-tooltip md-direction="bottom" md-delay="500"> Отправлено {{ document.last_email.user.login }} ({{ document.last_email.user.id }}) на {{ document.last_email.email }}</md-tooltip>
            </div>

            <div v-if="document.agent && document.agent.id">
                <span>{{'Принципал: ' + document.agent.name + ((document.agent.inn) ? (', ' + document.agent.inn) : ((document.agent.passport_number) ? (', ' + document.agent.passport_number) : '') ) }}</span>
            </div>

            <div v-if="document.customer && document.customer.id">
                <span>{{ 'Контрагент: ' + document.customer.inn + ', ' + document.customer.name}}</span>
            </div>
        </div>

        <ZDialog v-bind:active.sync="editDialog">
            <template slot="title">Редактирование документа</template>
            <template slot="default">
                <div v-if="(!deal.executor || parseInt(deal.executor.nds) !== 0) && editDoc.agent_id">
                    <div> Внимание, выбран исполнитель с НДС! </div>
                    <div> Указание принципала возможно только для исполнителя БЕЗ НДС. </div>
                    <div> Если документ был создан до изменения исполнителя, </div>
                    <div> выберете пункт "Без принципала" (текущий принципал будет удалён из документа) </div>
                </div>
                <div>
                    <!-- Разрашаем указывать принципала только акту и счёту фактуре, и выключаем поле, если компания - исполнитель не работает с принципалом (если она с НДС) -->
                    <z-select
                        v-if="(['invoice_a4', 'act_a4'].indexOf(editDoc.type)+1)"
                        
                        id="agent_id" name="agent_id" label="Принципал"
                        v-model="editDoc.agent_id"
                        v-validate="" data-vv-as=" " data-vv-name="agent_id" data-vv-scope="agent"
                        v-bind:error="errors.first('agent.agent_id')"
                    >
                        <option v-bind:value="null"> Без принципала </option>
                        <!-- Отображаем список принципалов только если выбрана компания БЕЗ НДС, иначе документы с принципалом создаваться не должны
                        И отображаем текущего выбранного принципала, но не даём его выбрать снова (чтобы было понятно, какой выбран) -->
                        <option
                            v-for="item in agents" v-bind:key="item.id" v-bind:value="item.id"
                            v-bind:disabled="(!deal.executor || parseInt(deal.executor.nds) !== 0)"
                            v-if="(deal.executor && parseInt(deal.executor.nds) === 0) || parseInt(item.id) === parseInt(editDoc.agent_id)"
                        >{{ item.label }}</option>
                    </z-select>

                    <z-select
                        v-if="(['invoice_a4', 'invoice'].indexOf(editDoc.type)+1)"
                        id="act_id" name="act_id" label="Прикреплённый акт"
                        v-model="editDoc.act_id"
                        v-validate="" data-vv-as=" " data-vv-name="act_id" data-vv-scope="related"
                        v-bind:error="errors.first('related.act_id')"
                    >
                        <option v-bind:value="null">Не выбран</option>
                        <option
                            v-for="item in acts" v-bind:key="`related-${item.id}`" v-bind:value="item.id"
                        >{{ item.label }}</option>
                    </z-select>

                    <z-date
                        v-model="editDoc.created_at" placeholder="Дата платежа" required label="Дата создания"
                        v-bind:return-string="false" format="DD.MM.YYYY HH:mm:ss" type="datetime"
                        data-vv-name="date" v-bind:data-vv-as="' '" v-bind:error="(errors.first('date') ? ('Укажите корректную дату (между датой создания заявки и датой выдачи груза клиенту)') : null )"
                        v-validate="dateValidationRules"
                    ></z-date>                    
                </div>
            </template>
            <template slot="actions">
                <z-button primary v-on:click="editDialog = false"> Отмена </z-button>
                <z-button primary v-on:click="editDocument()" accent> Сохранить </z-button>
            </template>
        </ZDialog>

        <ZDialog v-bind:active.sync="sendDocDialog">
            <template slot="title">Отправка документа</template>
            <template slot="default">
                <z-select
                    id="document-recipient"
                    name="document_recipient"
                    label="E-mail получателя"
                    v-validate="'required'"
                    v-bind:error="errors.first('document_recipient')"
                    v-model="documentRecipient"
                >
                    <option v-for="contact in contacts" v-bind:key="contact.id" v-bind:value="contact.id"> {{ contact.email }} {{ contact.name ? '(' + contact.type_name + ')' : '' }} </option>
                    <option value="other"> Другой... </option>
                </z-select>
                <z-input
                    label="Ваш e-mail"
                    v-if="documentRecipient == 'other'"
                    v-model="documentRecipientOther"
                    name="document_recipient_other"
                    id="document-recipient-other"
                    v-validate="'email|required'"
                    v-bind:error="errors.first('document_recipient_other')"
                    data-vv-name="document_recipient_other"
                    v-bind:data-vv-as="' '"
                ></z-input>
            </template>
            <template slot="actions">
                <z-button primary v-on:click="sendDocDialog = false"> Отмена </z-button>
                <z-button primary v-on:click="sendDoc()" accent> Отправить </z-button>
            </template>
        </ZDialog>
    </div>
</template>
<script>
    import ZDialog from '@/components/ZDialog';
    import ZDate   from '@/components/ZDate';
    import ZSelect from '@/components/ZSelect';
    import ZInput  from '@/components/ZInput';
    import ZIcon   from '@/components/ZIcon.vue';
    import ZButton from '@/components/ZButton';
    export default {
        name: 'doc',
        props: {
            document: {
                type: Object,
                default: () => {}
            },
            deal: {
                type: Object,
                default: () => {}
            },
            removable: {
                type: Boolean,
                default: true
            }
        },
        components: { ZDate, ZSelect, ZInput, ZIcon, ZButton, ZDialog },
        watch: {
            'document.id'(id) {
                this.$refs.documentIframe.style.visibility = 'hidden';
                if (id) this.$store.commit('showProgressBar', 'load-doc-card');
            }
        },
        data() {
            return {
                editDialog: false,
                sendDocDialog: false,
                documentRecipient: '',
                documentRecipientOther: '',
                agents: [],
                defaultDoc: {
                    id: null,
                    deal_id: null,
                    type: null,
                    user_id: null,
                    last_print_date: null,
                    last_print_user_id: null,
                    created_at: null,
                    updated_at: null,
                    data: null,
                    agent_id: null,
                    executor_id: null,
                    number: null,
                    last_printer: null,
                    act_id: null,
                },
                editDoc: {
                    id: null,
                    deal_id: null,
                    type: null,
                    user_id: null,
                    last_print_date: null,
                    last_print_user_id: null,
                    created_at: null,
                    updated_at: null,
                    data: null,
                    agent_id: null,
                    executor_id: null,
                    number: null,
                    last_printer: null,
                    act_id: null,
                },
                labels: {
                    bill:       'Счёт',
                    invoice_a4: 'Счёт фактура',
                    assignment: 'Поручение экспедитору',
                    receipt:    'Экспедиторская расписка',
                    act_a4:     'Акт выполненных работ',
                    stock_note: 'Складская записка',
                    route_list: 'Маршрутный лист'
                }
            }
        },
        computed: {
            progressObj() {
                return this.$store.state.progressObj;
            },
            progressDocs() {
                return this.progressObj['load-doc-card'];
            },
            statusName() {
                switch (this.document.status) {
                    case 'ACTUAL': return 'Актуальный';
                    case 'DELETED': return 'Удалённый';
                }
            },
            previewUrl() {
                return this.endpoint + '/print/preview/' + this.document.id;
            },
            endpoint() {
                return this.$store.state.endpoint;
            },
            user() {
                return this.$store.state.users.current;
            },
            isUserAdmin() {
                return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('administrators')+1) : false;
            },
            dateValidationRules() {
                let rules = {'required': true};
                if (this.minDocDate) rules.after  = this.moment(this.minDocDate).tz(this.$root.userTimezone).toDate();
                if (this.maxDocDate) rules.before = this.moment(this.maxDocDate).tz(this.$root.userTimezone).toDate();
                return rules;
            },
            contacts() {
                let contacts = [];
                let members = ['sender', 'recipient', 'payer'];

                members.forEach(member => {
                    if (
                        typeof this.deal[member] !== 'undefined' &&
                        this.deal[member] &&
                        this.deal[member].email &&
                        this.deal[member].email.length > 0
                    ) {
                        contacts.push({
                            id: member,
                            email: this.deal[member].email,
                            name: null,
                            type: member
                        });
                    }
                });

                this.deal.contacts.forEach(contact => {
                    if (contact.contact.email && contact.contact.email.length > 0) {
                        contact.contact.type = contact.type;
                        contact.contact.id = contact.id;
                        contacts.push(contact.contact);
                    }
                });

                contacts.forEach(contact => {
                    contact.type_name = '';
                    switch (contact.type) {
                        case 'sender':    contact.type_name = 'отправитель'; break;
                        case 'recipient': contact.type_name = 'получатель'; break;
                        case 'payer':
                            contact.type_name = 'плательщик';
                            if (contact.type == 'payer') this.documentRecipient = contact.id;
                        break;
                    }
                });

                return contacts;
            },
            documents() {
                if (!this.$props.deal || !this.$props.deal.documents) return [];
                return this.$props.deal.documents.filter(doc => this.$props.document && this.$props.document.customer_id && doc.customer_id == this.$props.document.customer_id);
            },
            acts() {
                return this.documents.filter(item => item.type == 'act_a4' || item.type == 'act').map(item => {
                    item.label = `№${item.number}`;

                    if (`${item.status}`.toUpperCase() == 'DELETED') item.label += ' - удален';
                    if (`${item.status}`.toUpperCase() == 'ACTUAL')  item.label += ' - актуален';
                    if (item.customer)
                        item.label += ` - ${item.customer.type == 2 ? item.customer.passport_number : item.customer.inn}, ${item.customer.name}`;

                    return item;
                })
            }
        },
        created() {
            this.$nextTick(() => {
                this.getAgents();
                this.$store.commit('showProgressBar', 'load-doc-card');
                if (navigator.userAgent.indexOf("MSIE") > -1 && !window.opera) {
                    this.$refs.documentIframe.onreadystatechange = () => {
                        if (this.$refs.documentIframe.readyState == "complete") {     
                            this.$refs.documentIframe.style.visibility = 'visible';
                            this.$store.commit('hideProgressBar', 'load-doc-card');
                        }
                    };   
                } else {
                    this.$refs.documentIframe.onload = () => {
                        this.$refs.documentIframe.style.visibility = 'visible';
                        this.$store.commit('hideProgressBar', 'load-doc-card');
                    };  
                }
            });
        },
        methods: {
            /**
             * Открывает новое окно с печатью документа
             */
            printDoc() {
                let url = this.endpoint + '/print/' + this.document.type + '?deal_id=' + this.document.deal_id + '&user_id=' + this.user.id + '&doc_id=' + this.document.id
                window.open(url, '_blank', 'width=1024,height=768');
            },
            /**
             * Обновление данных документа
             */
            updateDoc() {
                this.$root.$emit('z-alert', 'Обновить документ?', null, () => {
                    this.$store.commit('showProgressBar', 'load-doc-card');
                    this.$store.dispatch('deals/updateDocument', this.document.id)
                        .then(() => this.$emit('refresh-doc'))
                        .finally(() => this.$store.commit('hideProgressBar', 'load-doc-card'));    
                });
            },
            /**
             * Удаление документа
             */
            removeDoc() {
                this.$root.$emit('z-alert', 'Удалить документ?', null, () => {
                    this.$store.commit('showProgressBar', 'load-doc-card');
                    this.$store.dispatch('deals/deleteDocument', this.document.id)
                        .then(() => this.$emit('refresh-doc'))
                        .finally(() => this.$store.commit('hideProgressBar', 'load-doc-card'));
                });
            },
            /**
             * Открывает диалог редактирования документа
             */
            showEditDialog() {
                if (this.document.related && Array.isArray(this.document.related) && this.document.related.length) {
                    this.document.act = this.document.related.find(doc => doc.type == 'act');
                    if (this.document.act && this.document.act.id) this.document.act_id = this.document.act.id;
                }
                this.editDoc = Object.assign({}, this.document);
                this.editDialog = true;
            },
            /**
             * Отправляет запрос с обновлёнными данными документа
             */
            editDocument() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.commit('showProgressBar', 'load-doc-card');
                    this.editDialog = false;
                    this.$store.dispatch('deals/putDocument', {
                        id:         this.editDoc.id,
                        created_at: this.editDoc.created_at,
                        agent_id:   this.editDoc.agent_id,
                        type:       this.editDoc.type,
                        deal_id:    this.editDoc.deal_id,
                        act_id:     this.editDoc.act_id
                    }).then(() => {
                        this.$emit('refresh-doc');
                        this.editDoc = Object.assign({}, this.defaultDoc);
                        this.editDialog = false;
                    }).catch(() => null).finally(() => this.$store.commit('hideProgressBar', 'load-doc-card'));
                });
            },
            /**
             * Удаляет документ
             */
            restoreDoc() {
                let label = this.labels[this.document.type];
                const docExecutorID  = (this.document    && this.document.executor_id)            ? parseInt(this.document.executor_id)            : null;
                const dealExecutorID = (this.$props.deal && this.$props.deal.executor_company_id) ? parseInt(this.$props.deal.executor_company_id) : null;

                let message = `Вы уверены, что хотите восстановить документ ${label}?`;
                let description = null;
                if (docExecutorID !== dealExecutorID)
                    description = `<p style="text-align: center; color: red;">ВНИМАНИЕ!<br><br>Исполнитель заявки не совпадает с исполнителем документа!<br>Документ не подлежит выгрузке в 1С!</p>`;

                this.$root.$emit('z-alert', message, description, () => {
                    this.$store.commit('showProgressBar', 'load-doc-card');
                    this.$store.dispatch('deals/restoreDocument', this.document.id)
                        .then(() => this.$emit('refresh-doc'))
                        .finally(() => this.$store.commit('hideProgressBar', 'load-doc-card'));
                });
            },
            /**
             * Отправляет документ на указанный пользователем email
             */
            sendDoc() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;

                    const data = {documents: [this.document.id]};
                    if (this.documentRecipient == 'other') data.email = this.documentRecipientOther;
                    else {
                        const contact = this.contacts.find(contact => contact.id == this.documentRecipient);
                        data.email = contact.email;
                        if (contact.name) data.name = contact.name;
                    }
                    
                    this.sendDocDialog = false;

                    this.$store.commit('showProgressBar', 'load-doc-card');
                    this.$store.dispatch('deals/sendDocumentsByEmail', data)
                        .finally(() => this.$store.commit('hideProgressBar', 'load-doc-card'));
                });
            },
            /**
             * Получает список принципалов с бекенда
             */
            getAgents() {
                this.$store.commit('showProgressBar', 'load-doc-card');
                return this.$store.dispatch('customers/getCustomers', {
                    page: 1, order_by: 'id', order_type: 'asc', count: 'all',
                    filter: {model: [['is_agent', '=', 1]], relation: []}, cache: true
                }).then(r => {
                    if (r && r.length) this.agents = Object.assign([], r.map(item => {
                        return {
                            id: item.id,
                            label: ((item.inn) ? (item.inn + ': ') : ((item.passport_number) ? (item.passport_number + ': ') : '')) + item.name
                        };
                    }));
                }).finally(() => this.$store.commit('hideProgressBar', 'load-doc-card'));
            }
        }
    }
</script>
<style lang="sass" scoped>
    .document
        height: 100%
        display: flex
        iframe
            height: 100%
            width: calc(100% - 300px)
            border: 0
            overflow: auto
            flex: 1 1 auto
        .info
            flex: 0 0 300px
            border-left: 1px solid rgba(0, 0, 0, 0.12)
            padding: 0 10px
            .md-button
                min-width: 40px
        .button-container
            display: flex
            flex-direction: column
            a 
                text-decoration: none
                i 
                    margin-right: 8px
                + a
                    margin-top: 6px
            .button-text
                color: var(--color-primary-500)
                &:hover
                    color: var(--color-primary-300)
            .z-icon
                margin-right: 10px
            .document-button
                display: flex
                justify-content: start
                align-items: center
                border-radius: 3px
</style>


// WEBPACK FOOTER //
// Doc.vue?81ccb1b8